import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { getCallLogs, getCallDetails, getCallerInfo } from "./services/soar";
import { formatPhoneNumber } from "../scripts/helperScripts";

function CallHistory(props) {
  const { divisionId } = useParams();
  const [logs, setLogs] = useState([]);
  const [selectedCall, setSelectedCall] = useState("");
  const [callDetails, setCallDetails] = useState([]);
  const [callerInfo, setCallerInfo] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getCallLogs(divisionId).then((response) => {
      setLogs(JSON.parse(response).OnCall.Parent);
      setLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (selectedCall !== "") {
      console.log("Getting Call Details for ", selectedCall);
      getCallDetails(selectedCall).then((response) => {
        setCallDetails(JSON.parse(response).OnCall.Instance);
      });
    }
  }, [selectedCall]);

  const callerPhoneLookup = (phone) => {
    console.log("Phone length ", phone.length);
    const trimPhone = phone.length === 11 ? phone.slice(1) : phone;
    getCallerInfo(trimPhone).then((response) => {
      const data = JSON.parse(response).resultset.result;
      setCallerInfo(data && data.length > 0 ? data[0] : {});
    });
  };

  const callInfo = (id) => {
    console.log("call info", id, selectedCall, selectedCall === id);
    if (selectedCall === id) {
      console.log("call info already set, unsetting");
      setSelectedCall("");
    } else {
      console.log("setting call info");
      setSelectedCall(id);
    }
  };

  return loaded ? (
    <>
      {logs && logs.length > 0 ? (
        <>
          <div className="row px-2 mx-2">
            <div className="col-4">From Phone Number</div>
            <div className="col-4">Date and Time</div>
            <div className="col-3">Duration of Call</div>
            <div className="col-1">Info</div>
          </div>
          {logs.map((call) => (
            <div key={call.ParentSid}>
              <div className="row border safy-border-2 border-dark rounded bg-light text-dark p-2 m-2">
                <div className="col-4">
                  {formatPhoneNumber(call.CallerPhone)}
                </div>
                <div className="col-4">
                  {moment(call.TrackedDateTimeUTC).format("MM/DD/YYYY HH:mm")}
                </div>
                <div className="col-3">{call.ProcessLengthMinutes}</div>
                <div
                  className="col-1"
                  onClick={() => {
                    callInfo(call.ParentSid);
                    setCallerInfo({});
                    callerPhoneLookup(call.CallerPhone);
                  }}
                >
                  <i className="fa fa-info"></i>
                </div>
              </div>
              {selectedCall === call.ParentSid ? (
                <>
                  {Object.keys(callerInfo).length > 0 && (
                    <div className="m-2 p-4 bg-warning rounded">
                      {`Caller may be ${callerInfo.FullName} - ${callerInfo.Information}`}
                    </div>
                  )}
                  <div className="row mx-4 px-1">
                    <div className="col-1">Type</div>
                    <div className="col-11">
                      <div className="row mb-1">
                        <div className="col-4">To Phone</div>
                        <div className="col-4">To User</div>
                        <div className="col-4">Time</div>
                      </div>
                      <div className="row mb-1">
                        <div className="col">Description</div>
                      </div>
                    </div>
                  </div>
                  {callDetails &&
                    callDetails.map((item) => (
                      <div
                        className={
                          item.InstanceType === "call"
                            ? "mx-4 rounded bg-success text-white"
                            : "mx-4 rounded bg-safy-info text-white"
                        }
                      >
                        <div className="row ms-2 p-2">
                          <div className="col-1">
                            <i
                              className={
                                item.InstanceType === "call"
                                  ? "fa fa-phone fa-3x pt-3"
                                  : "fa fa-comment fa-3x pt-3"
                              }
                            />
                          </div>
                          <div className="col-11">
                            <div className="row">
                              <div className="col-4">
                                {formatPhoneNumber(item.ADUserPhone)}
                              </div>
                              <div className="col-4">{item.ADUser}</div>
                              <div className="col-4">
                                {moment(item.TrackedDateTime).format(
                                  "MM/DD/YYYY HH:mm"
                                )}
                              </div>
                            </div>
                            <div className="row p-2">
                              {item.InstanceMessage}
                            </div>
                          </div>
                        </div>
                        <hr></hr>
                      </div>
                    ))}
                </>
              ) : null}
            </div>
          ))}
        </>
      ) : (
        <div className="h5">No Calls for this Division</div>
      )}
    </>
  ) : (
    <div className="h5">Loading Call Logs</div>
  );
}

export default CallHistory;
